import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from './table';

export interface ColumnProps<T> {
  header: string;
  field?: keyof T;
  render?: (item: T) => React.ReactNode;
}

interface DataTableProps<T> {
  data: T[];
  columns: ColumnProps<T>[];
  emptyMessage?: string;
}

export function DataTable<T extends { id: number }>({
  data,
  columns,
  emptyMessage = '',
}: DataTableProps<T>) {
  return (
    <>
      <Table>
        <TableHeader>
          <TableRow>
            {columns.map((column, index) => (
              <TableHead key={column.header || `header-${index}`}>
                {column.header}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {data.map((item: T) => (
            <TableRow key={item.id}>
              {columns.map((column: ColumnProps<T>, index) => (
                <TableCell key={column.header || `row-${index}`}>
                  {column.render
                    ? column.render(item)
                    : String(item[column.field!])}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {data.length === 0 && (
        <p className="text-center py-5 text-muted-foreground text-sm">
          {emptyMessage}
        </p>
      )}
    </>
  );
}
